import React from "react";
import { useSection } from "../SectionContext/SectionContext";

const BtnSubmitMobile = () => {
  const { activeSection, setActiveSection } = useSection();
  const toggleSection = () => {
    setActiveSection((prevSection) =>
      prevSection === "banners" ? "portfolio" : "banners"
    );
  };
  return (
    <div className="container-btnMobile" onClick={toggleSection}>
      <span>
        {activeSection === "banners" ? (
          <>
            <span>Projets</span> <span>Projets</span>
          </>
        ) : (
          <>
            <span>Accueil</span> <span>Accueil</span>
          </>
        )}
      </span>
      ;
    </div>
  );
};

export default BtnSubmitMobile;
